import React from 'react';

const DepartmentFilterContext = React.createContext<{
  selectedDepartmentIds: number[];
  fetchUserDepartmentSettings(): void;
}>({ selectedDepartmentIds: [], fetchUserDepartmentSettings: () => undefined });

export default DepartmentFilterContext;
